// Section types whose per-item objects carry a stable, AI-targetable `id`,
// mapped to the array key holding those items. Mirrors agendaBasic — the one
// section that already had item ids.
const PRESET_ITEM_ID_SECTION_KEYS = {
  collapsibleBasic: 'items',
  galleryBasic: 'items',
  gridBasic: 'items',
  speakersBasic: 'items',
  sponsorsBasic: 'items',
  barNavigation: 'items',
  mapBasic: 'items',
  formBasic: 'fields',
};

export const useBuilderStore = defineStore('builder', {
  state: () => {
    return {
      lang: null,
      activeSectionId: null,
      visibleSectionIds: [],
      isPopoverOpen: false,
      page: {
        presets: [
          {
            id: 'page-header-1',
            category: 'header',
            title: useT('builder.page.photo.large'),
          },
          {
            id: 'page-header-2',
            category: 'header',
            title: useT('builder.page.photo.largeWithBox'),
          },
          {
            id: 'page-header-3',
            category: 'header',
            title: useT('builder.page.photo.largeWithCaption'),
          },
          {
            id: 'page-header-4',
            category: 'header',
            title: useT('builder.page.photo.graphicsOrEventPhoto'),
          },

          {
            id: 'page-about-1',
            category: 'about',
            title: useT('news.title'),
          },
          {
            id: 'page-about-2',
            category: 'about',
          },
          {
            id: 'page-about-3',
            category: 'about',
            title: useT('builder.page.grid.singleColumn'),
          },
          {
            id: 'page-about-4',
            category: 'about',
          },
          {
            id: 'page-about-5',
            category: 'about',
          },

          {
            id: 'page-about-6',
            category: 'about',
            title: useT('builder.page.grid.twoColumns'),
          },
          {
            id: 'page-about-7',
            category: 'about',
          },
          {
            id: 'page-about-8',
            category: 'about',
          },

          {
            id: 'page-speakers-1',
            category: 'speakers',
          },
          {
            id: 'page-speakers-2',
            category: 'speakers',
          },
          {
            id: 'page-speakers-3',
            category: 'speakers',
          },
          {
            id: 'page-speakers-4',
            category: 'speakers',
          },

          {
            id: 'page-agenda-1',
            category: 'agenda',
            title: useT('builder.page.event.oneDay'),
          },
          {
            id: 'page-agenda-2',
            category: 'agenda',
          },
          {
            id: 'page-agenda-3',
            category: 'agenda',
          },

          {
            id: 'page-agenda-4',
            category: 'agenda',
            title: useT('builder.page.event.multiDay'),
          },
          {
            id: 'page-agenda-5',
            category: 'agenda',
          },
          {
            id: 'page-agenda-6',
            category: 'agenda',
          },

          {
            id: 'page-agenda-7',
            category: 'agenda',
            title: useT('builder.page.event.oneDayMultiStaging'),
          },

          {
            id: 'page-agenda-8',
            category: 'agenda',
            title: useT('builder.page.event.multiDayMultiStaging'),
          },

          {
            id: 'page-accommodations-1',
            category: 'accommodations',
          },
          {
            id: 'page-accommodations-2',
            category: 'accommodations',
          },
          {
            id: 'page-accommodations-3',
            category: 'accommodations',
          },
          {
            id: 'page-accommodations-4',
            category: 'accommodations',
          },

          {
            id: 'page-dresscode-1',
            category: 'dresscode',
          },
          {
            id: 'page-dresscode-2',
            category: 'dresscode',
          },
          {
            id: 'page-dresscode-3',
            category: 'dresscode',
          },

          {
            id: 'page-location-1',
            category: 'location',
            title: useT('builder.page.map'),
          },

          {
            id: 'page-location-2',
            category: 'location',
            title: useT('builder.page.textImage'),
          },

          {
            id: 'page-sponsors-1',
            category: 'sponsors',
          },
          {
            id: 'page-sponsors-2',
            category: 'sponsors',
          },
          {
            id: 'page-sponsors-3',
            category: 'sponsors',
          },
          {
            id: 'page-sponsors-4',
            category: 'sponsors',
          },
          {
            id: 'page-sponsors-5',
            category: 'sponsors',
          },

          {
            id: 'page-form-1',
            category: 'form',
          },
          {
            id: 'page-form-2',
            category: 'form',
          },

          {
            id: 'page-footer-1',
            category: 'footer',
            title: useT('builder.page.contactUs'),
          },

          {
            id: 'page-footer-2',
            category: 'footer',
            title: useT('builder.page.footer'),
          },
          {
            id: 'page-footer-3',
            category: 'footer',
          },

          {
            id: 'page-bar-1',
            category: 'bar',
            title: useT('builder.attribute.withNavigation'),
          },
          {
            id: 'page-bar-2',
            category: 'bar',
          },
          {
            id: 'page-bar-3',
            category: 'bar',
          },

          {
            id: 'page-bar-4',
            category: 'bar',
            title: useT('common.basic'),
          },

          {
            id: 'page-grid-1',
            category: 'grid',
            title: useT('builder.attribute.withPicture'),
          },
          {
            id: 'page-grid-2',
            category: 'grid',
          },
          {
            id: 'page-grid-3',
            category: 'grid',
          },
          {
            id: 'page-grid-4',
            category: 'grid',
            title: useT('builder.attribute.withIcon'),
          },
          {
            id: 'page-grid-5',
            category: 'grid',
          },
          {
            id: 'page-grid-6',
            category: 'grid',
          },
          {
            id: 'page-grid-7',
            category: 'grid',
          },
          {
            id: 'page-grid-8',
            category: 'grid',
          },

          {
            id: 'page-collapsible-1',
            category: 'collapsible',
          },
          {
            id: 'page-collapsible-2',
            category: 'collapsible',
          },

          {
            id: 'page-image-1',
            category: 'image',
            title: useT('common.basic'),
          },
          {
            id: 'page-image-2',
            category: 'image',
          },
          {
            id: 'page-image-3',
            category: 'image',
            title: useT('builder.attribute.narrowedGrid'),
          },

          {
            id: 'page-text-1',
            category: 'text',
          },
          {
            id: 'page-text-2',
            category: 'text',
          },
          {
            id: 'page-text-3',
            category: 'text',
          },
          {
            id: 'page-text-4',
            category: 'text',
          },
          {
            id: 'page-text-5',
            category: 'text',
          },
          {
            id: 'page-text-6',
            category: 'text',
          },
          {
            id: 'page-text-7',
            category: 'text',
          },

          {
            id: 'page-map-1',
            category: 'map',
            title: useT('builder.page.map'),
          },

          {
            id: 'page-divider-1',
            category: 'divider',
          },
          {
            id: 'page-divider-2',
            category: 'divider',
          },
          {
            id: 'page-divider-3',
            category: 'divider',
          },
          {
            id: 'page-gallery-1',
            category: 'gallery',
            title: useT('builder.page.grid.threeColumns'),
          },
          {
            id: 'page-gallery-2',
            category: 'gallery',
            title: useT('builder.page.photogrid.dynamic'),
          },
          {
            id: 'page-gallery-3',
            category: 'gallery',
            title: useT('builder.page.grid.fourColumns'),
          },
        ],

        categories: [
          {
            id: 'header',
            title: useT('builder.attribute.header'),
            icon: 'image-03',
            isMain: true,
          },
          {
            id: 'about',
            title: useT('poly.aboutEvent'),
            icon: 'type-01',
            isMain: true,
          },
          {
            id: 'speakers',
            title: useT('poly.speakers'),
            icon: 'users-02',
            isMain: true,
          },
          {
            id: 'agenda',
            title: useT('poly.agenda'),
            icon: 'calendar',
            isMain: true,
          },
          {
            id: 'accommodations',
            title: useT('builder.attribute.accommodation'),
            icon: 'home-02',
            isMain: true,
          },
          {
            id: 'dresscode',
            title: useT('builder.attribute.dressCode'),
            icon: 'custom/dresscode',
            isMain: true,
          },
          {
            id: 'location',
            title: useT('builder.attribute.location'),
            icon: 'marker-pin-01',
            isMain: true,
          },
          {
            id: 'sponsors',
            title: useT('poly.partners'),
            icon: 'building-07',
            isMain: true,
          },
          {
            id: 'form',
            title: useT('builder.attribute.form'),
            icon: 'text-input',
            isMain: true,
          },
          {
            id: 'footer',
            title: useT('builder.page.footer'),
            icon: 'info-circle',
            isMain: true,
          },
          {
            id: 'bar',
            title: useT('builder.attribute.menu'),
            isMain: false,
            icon: 'menu-01',
          },
          {
            id: 'grid',
            title: useT('builder.attribute.grid'),
            icon: 'grid-01',
            isMain: false,
          },
          {
            id: 'collapsible',
            title: useT('builder.attribute.collapsibleList'),
            icon: 'custom/dots',
            isMain: false,
          },
          {
            id: 'image',
            title: useT('common.image'),
            icon: 'image-03',
            isMain: false,
          },
          {
            id: 'gallery',
            title: useT('builder.attribute.gallery'),
            isMain: false,
            icon: 'grid',
          },
          {
            id: 'text',
            title: useT('builder.section.text'),
            icon: 'custom/align-left',
            isMain: false,
          },
          {
            id: 'map',
            title: useT('builder.page.map'),
            isMain: false,
            icon: 'map-01',
          },
          {
            id: 'divider',
            title: useT('builder.attribute.divider'),
            isMain: false,
            icon: 'custom/divider',
          },

        ],
      },
      email: {
        presets: [
          {
            id: 'email-image-1',
            category: 'image',
          },
          {
            id: 'email-image-2',
            category: 'image',
          },
          {
            id: 'email-image-3',
            category: 'image',
          },
          {
            id: 'email-image-4',
            category: 'image',
          },

          {
            id: 'email-text-1',
            category: 'text',
          },
          {
            id: 'email-text-2',
            category: 'text',
          },
          {
            id: 'email-text-3',
            category: 'text',
          },
          {
            id: 'email-text-4',
            category: 'text',
          },
          {
            id: 'email-text-5',
            category: 'text',
          },

          {
            id: 'email-button-1',
            category: 'button',
          },
          {
            id: 'email-button-2',
            category: 'button',
          },
          {
            id: 'email-button-3',
            category: 'button',
          },
          {
            id: 'email-button-4',
            category: 'button',
          },
          {
            id: 'email-button-5',
            category: 'button',
          },
          {
            id: 'email-button-6',
            category: 'button',
          },

          {
            id: 'email-list-1',
            category: 'list',
          },
          {
            id: 'email-list-2',
            category: 'list',
          },
          {
            id: 'email-list-3',
            category: 'list',
          },
          {
            id: 'email-list-4',
            category: 'list',
          },
          {
            id: 'email-list-5',
            category: 'list',
          },
          {
            id: 'email-list-6',
            category: 'list',
          },

          {
            id: 'email-divider-1',
            category: 'divider',
          },
          {
            id: 'email-divider-2',
            category: 'divider',
          },
          {
            id: 'email-divider-3',
            category: 'divider',
          },

          {
            id: 'email-map-1',
            category: 'map',
          },

          // {
          //   id: 'email-guest-1',
          //   category: 'guest',
          // },
          {
            id: 'email-guest-2',
            category: 'guest',
          },
          {
            id: 'email-salutation-1',
            category: 'salutation',
          },
        ],
        categories: [
          {
            id: 'image',
            title: useT('common.image'),
            icon: 'image-03',
          },
          {
            id: 'salutation',
            title: useT('builder.email.salutation'),
            icon: 'edit-04',
          },
          {
            id: 'text',
            title: useT('poly.aboutEvent'),
            icon: 'type-01',
          },
          {
            id: 'button',
            title: useT('builder.page.form.button'),
            icon: 'custom/button',
          },
          {
            id: 'list',
            title: useT('builder.attribute.list'),
            icon: 'list',
          },
          {
            id: 'divider',
            title: useT('builder.attribute.divider'),
            icon: 'custom/divider',
          },
          {
            id: 'map',
            title: useT('builder.page.map'),
            icon: 'map-01',
          },
          {
            id: 'guest',
            title: useT('builder.attribute.guestInfo'),
            icon: 'user-03',
          },
        ],
      },
      options: {
        imageSize: [
          {
            id: 'small',
            icon: 'custom/size-s',
          },
          {
            id: 'medium',
            icon: 'custom/size-m',
          },
          {
            id: 'large',
            icon: 'custom/size-l',
          },
        ],
        imageCrop: [
          {
            id: 'circle',
            text: useT('builder.attribute.circle'),
            icon: 'circle',
          },
          {
            id: 'square',
            text: useT('builder.attribute.square'),
            icon: 'square',
          },
          {
            id: '4/3',
            text: useT('builder.attribute.ratio4to3'),
          },
          {
            id: '16/9',
            text: useT('builder.attribute.ratio16to9'),
          },
          {
            id: '3/4',
            text: useT('builder.attribute.ratio3to4'),
          },
          {
            id: 'original',
            text: useT('builder.attribute.original'),
          },
        ],
        spacer: [
          {
            id: 'none',
            icon: 'custom/size-none',
          },
          {
            id: 'small',
            icon: 'custom/size-s',
          },
          {
            id: 'medium',
            icon: 'custom/size-m',
          },
          {
            id: 'large',
            icon: 'custom/size-l',
          },
        ],
        alignment: [
          {
            id: 'left',
            icon: 'align-left',
          },
          {
            id: 'center',
            icon: 'align-center',
          },
          {
            id: 'right',
            icon: 'align-right',
          },
        ],
        arrangement: [
          {
            id: 'targetRight',
            icon: 'custom/align-left',
          },
          {
            id: 'targetLeft',
            icon: 'custom/align-right',
          },
        ],
        linkType: [
          {
            id: 'activePage',
            text: useT('builder.confirmationPage'),
            icon: 'check',
          },
          {
            id: 'denialPage',
            text: useT('builder.rejectPage'),
            icon: 'x-close',
          },
          // {
          //   id: 'guestAppAccess',
          //   text: useT('builder.linkToGuestApp'),
          //   icon: 'phone-01',
          // },
          {
            id: 'registrationPagePublicId',
            text: useT('builder.publicRegistrationLink'),
            icon: 'monitor-01',
          },
          {
            id: 'addToCalendar',
            text: useT('poly.addToCalendar'),
            icon: 'calendar-plus-02',
          },
          {
            id: 'customUrl',
            text: useT('builder.customUrl'),
            icon: 'globe-02-1',
          },
        ],
        contactLinkType: [
          {
            id: 'linkedin',
            text: useT('poly.linkedin'),
            icon: 'custom/logo-linkedin',
            tags: ['linkedin.com'],
          },
          {
            id: 'facebook',
            text: useT('poly.facebook'),
            icon: 'custom/logo-facebook',
            tags: ['facebook.com', 'fb.com'],
          },
          {
            id: 'instagram',
            text: useT('poly.instagram'),
            icon: 'custom/logo-instagram',
            tags: ['instagram.com', 'instagr.am'],
          },
          {
            id: 'x',
            text: useT('poly.x'),
            icon: 'custom/logo-x',
            tags: ['x.com', 'twitter.com'],
          },
          {
            id: 'mail',
            text: useT('poly.email'),
            icon: 'mail-01',
            tags: ['mailto:'],
          },
          {
            id: 'web',
            text: useT('poly.website'),
            icon: 'globe-01-1',
          },
        ],
        daysMode: [
          {
            id: 'rows',
            text: useT('builder.email.button.group.underneath'),
            icon: 'arrow-down',
          },
          {
            id: 'columns',
            text: useT('builder.email.button.group.sideBySide'),
            icon: 'arrow-right',
          },
          {
            id: 'tabs',
            text: useT('builder.attribute.tabbed'),
            icon: 'columns-03',
          },
        ],
        itemContainer: [
          {
            id: 'none',
            text: useT('builder.page.form.none'),
          },
          {
            id: 'box',
            text: useT('builder.attribute.box'),
          },
        ],
        itemDecoration: [
          {
            id: 'icon',
            text: useT('builder.attribute.icon'),
          },
          {
            id: 'image',
            text: useT('common.image'),
          },
        ],
        iconPlacement: [
          {
            id: 'top',
            text: useT('builder.attribute.top'),
          },
          {
            id: 'left',
            text: useT('builder.attribute.left'),
          },
        ],
      },
      formBasicShowSubmitted: false,
    };
  },

  actions: {
    replacePresetTokens({ presetString, primaryColor, appearance, replaces }) {
      const event = useEventStore().event;
      let result = presetString;

      const escapeStringForJSON = (content) => String(content || '')
        .replaceAll(/\\/g, '\\\\') // replace backslashes (must be first)
        .replaceAll(/\n/g, '<br>') // replace newlines
        .replaceAll(/\r/g, '\\r') // replace carriage returns
        .replaceAll(/\t/g, '\\t') // replace tabs
        .replaceAll(/\f/g, '\\f') // replace form feeds
        .replaceAll(/\v/g, '\\v') // replace vertical tabs
        .replaceAll(/\0/g, '\\0') // replace null bytes
        .replaceAll(/"/g, '\\"'); // replace double quotes

      if (replaces && Object.keys(replaces).length > 0) {
        Object.keys(replaces).forEach((key) => {
          result = result.replaceAll(key, escapeStringForJSON(replaces[`${key}`]));
        });
      }

      const appConfig = useAppConfig();

      result = result.replaceAll('{primaryColor}', primaryColor || useWorkspaceStore().identity?.primaryColor || useCssVar('--color-primary-500')?.value)
        .replace(/{id}/g, () => nanoid(10))
        .replaceAll('{appearance}', appearance || 'light')
        .replaceAll('{eventTitle}', escapeStringForJSON(event?.general?.title))
        .replaceAll('{fullLocation}', event?.general?.location?.placeName ? escapeStringForJSON(`${event?.general?.location?.placeName}, ${event?.general?.location?.address}, ${event?.general?.location?.city}, ${event?.general?.location?.zipCode}, ${event?.general?.location?.country}`) : '')
        .replaceAll('"{coordinatesLat}"', event?.general?.location?.coordinates?.lat || null)
        .replaceAll('"{coordinatesLng}"', event?.general?.location?.coordinates?.lng || null)
        .replaceAll('{placeName}', escapeStringForJSON(event?.general?.location?.placeName))
        .replaceAll('{logo}', useWorkspaceStore().identity?.logo || 'https://envelope-so.s3.us-east-1.amazonaws.com/envelope-logo.svg')
        .replaceAll('{eventFeaturedImage}', event?.general?.featuredImage || '')
        .replaceAll('{contactEmail}', escapeStringForJSON(event?.general?.contactEmail))
        .replaceAll('"{emailTemplateId}"', null)
        .replaceAll('{workspaceName}', escapeStringForJSON(useWorkspaceStore().name))
        .replaceAll('{appName}', escapeStringForJSON(appConfig.name))
        .replaceAll('{guestAppUrl}', `${useWorkspaceStore().getCustomOrigin(event)}/app/${event?._id}`);

      result = result.replaceAll('{startDate}', (match, index) => {
        const lang = _last(result.substring(0, index).match(/"_[a-z]{2}"/g))?.replace(/"/g, '').replace(/_/g, '');
        return getFormattedDate(
          event?.general?.startDate,
          {
            lang,
            format: 'LLL',
            timezone: event?.general?.timezone,
          },
        );
      });

      result = result.replaceAll('{fullDate}', (match, index) => {
        const lang = _last(result.substring(0, index).match(/"_[a-z]{2}"/g))?.replace(/"/g, '').replace(/_/g, '');
        return getFormattedDate(
          {
            start: event?.general?.startDate,
            end: event?.general?.endDate,
          },
          {
            lang,
            format: 'LLL',
            timezone: event?.general?.timezone,
          },
        );
      });

      return result;
    },
    // Stamp a stable id on every preset item/field that lacks one, so the
    // section types in PRESET_ITEM_ID_SECTION_KEYS are AI-targetable the same way
    // agendaBasic already is. Section ids come from the preset `{id}` token; item
    // ids are assigned here at load time rather than hard-coded in every preset.
    stampPresetItemIds(sections) {
      for (const section of sections || []) {
        const itemsKey = PRESET_ITEM_ID_SECTION_KEYS[section?.type];
        const items = itemsKey && section.data?.[itemsKey];
        if (!Array.isArray(items)) continue;

        items.forEach((item) => {
          if (item && typeof item === 'object' && !item.id) {
            item.id = nanoid(10);
          }
        });
      }

      return sections;
    },
    async getPresetTemplate({ id, type, replaces }) {
      const templateString = await $fetch(`/presets/${type}/templates/${id}.json`)
        .then((response) => JSON.stringify(response))
        .catch(() => {
          console.warn('Preset template not found', { id, type });
          return '{}';
        });

      const presetTemplate = JSON.parse(this.replacePresetTokens({ presetString: templateString, replaces }));

      this.stampPresetItemIds(presetTemplate?.sections);

      if (presetTemplate?.params && useWorkspaceStore().identity?.font) {
        presetTemplate.params.font = useWorkspaceStore().identity?.font;
      }

      presetTemplate.name = presetTemplate[`_${useEventStore().defaultLang}`]?.name || presetTemplate.name;

      console.log('presetTemplate', presetTemplate);

      return presetTemplate;
    },
    async getPresetSections({ id, template }) {
      const sectionsString = await $fetch(`/presets/${template?.type}/${id}.json`)
        .then((response) => JSON.stringify(response))
        .catch(() => {
          console.warn('Preset sections not found', { id, template });
          return '[]';
        });

      let sections = JSON.parse(this.replacePresetTokens({ presetString: sectionsString, primaryColor: template?.params?.primaryColor, appearance: template?.params?.appearance }));

      sections = sections.map((section) => {
        return {
          ...section,
          data: {
            hasRestrictedVisibility: false,
            visibleOnlyTo: [],
            ...section.data,
          },
        };
      });

      return this.stampPresetItemIds(sections);
    },

    isTranslated(item) {
      const langs = useEventStore().event?.general?.langs || [];
      let isTranslated = true;

      langs.forEach((lang) => {
        const modelValues = Object.values(item[`_${lang}`] || {}).filter((value) => !!value);

        if (!modelValues?.length && isTranslated) {
          isTranslated = false;
        }
      });

      return isTranslated;
    },

    pushVisibleSectionId(id) {
      if (!this.visibleSectionIds.includes(id)) {
        this.visibleSectionIds.push(id);
      }
    },

    pullVisibleSectionId(id) {
      if (this.visibleSectionIds.includes(id)) {
        this.visibleSectionIds = this.visibleSectionIds.filter((sectionId) => sectionId !== id);
      }
    },
  },

  getters: {
    getAppearances() {
      return (primaryColor) => {
        const tokenColors = useTokenColors(primaryColor);
        return [
          {
            id: 'light',
            text: useT('builder.color.light'),
            thumbnail: '/img/appearance/light.svg',
          },
          {
            id: 'lightGray',
            text: useT('builder.color.lightGrey'),
            thumbnail: '/img/appearance/light-gray.svg',
          },
          {
            id: 'dark',
            text: useT('builder.color.dark'),
            thumbnail: '/img/appearance/dark.svg',
          },
          {
            id: 'darkGray',
            text: useT('builder.color.darkGrey'),
            thumbnail: '/img/appearance/dark-gray.svg',
          },
          {
            id: 'accent',
            text: useT('builder.color.accent'),
            thumbnail: `/api/public/colorized.svg?path=/img/appearance/accent.svg&color=${encodeURIComponent(tokenColors?.colorPalette.value['builder-primary-500'])}`,
          },
          {
            id: 'lightAccent',
            text: useT('builder.color.lightAccent'),
            thumbnail: `/api/public/colorized.svg?path=/img/appearance/light-accent.svg&color=${encodeURIComponent(tokenColors?.colorPalette.value['builder-primary-100'])}`,
          },
        ];
      };
    },

    getContactLinkType(state) {
      return (id) => state.options.contactLinkType.find((link) => link.id === id) || null;
    },

    isVisibleSection(state) {
      return (id) => state.visibleSectionIds.includes(id);
    },

    getSectionName() {
      return (sectionType) => {
        const sectionNamespaces = [
          {
            type: 'agendaBasic',
            name: useT('poly.agenda'),
          },
          {
            type: 'barBasic',
            name: useT('builder.attribute.menuBasic'),
          },
          {
            type: 'barNavigation',
            name: useT('builder.attribute.menuNavigation'),
          },
          {
            type: 'collapsibleBasic',
            name: useT('builder.attribute.collapsibleList'),
          },
          {
            type: 'dividerBasic',
            name: useT('builder.attribute.divider'),
          },
          {
            type: 'formBasic',
            name: useT('builder.attribute.form'),
          },
          {
            type: 'gridBasic',
            name: useT('builder.attribute.grid'),
          },
          {
            type: 'headerBasic',
            name: useT('builder.attribute.headerBasic'),
          },
          {
            type: 'headerBottomBox',
            name: useT('builder.attribute.headerBottomBox'),
          },
          {
            type: 'headerTopBlock',
            name: useT('builder.attribute.headerUpperBox'),
          },
          {
            type: 'imageBasic',
            name: useT('builder.attribute.imageBasic'),
          },
          {
            type: 'imageNarrow',
            name: useT('builder.attribute.imageNarrowerContainer'),
          },
          {
            type: 'mapBasic',
            name: useT('builder.page.map'),
          },
          {
            type: 'speakersBasic',
            name: useT('poly.speakers'),
          },
          {
            type: 'sponsorsBasic',
            name: useT('poly.partners'),
          },
          {
            type: 'textBasic',
            name: useT('builder.attribute.textBase'),
          },
          {
            type: 'textNarrow',
            name: useT('builder.attribute.textNarrowerContainer'),
          },
          {
            type: 'textTwoColumns',
            name: useT('builder.attribute.textTwoColumns'),
          },
          {
            type: 'textWithImage',
            name: useT('builder.attribute.textTextImage'),
          },
          {
            type: 'galleryBasic',
            name: useT('builder.attribute.gallery'),
          },
        ];

        return sectionNamespaces.find((sectionNamespace) => sectionNamespace.type === sectionType)?.name;
      };
    },

    getDummyGuest() {
      return (lang, customProperties) => {
        const properties = {
          firstName: useT('poly.example.firstName', {}, { locale: lang || 'en' }),
          lastName: useT('poly.example.lastName', {}, { locale: lang || 'en' }),
          email: useT('poly.example.email', {}, { locale: lang || 'en' }),
          lang,
        };

        (customProperties || useEventStore().event?.guestlist?.properties || []).forEach((property) => {
          if (property.type === 'text') {
            properties[property.id] = useT('poly.example.text', {}, { locale: lang || 'en' });
          }

          if (property.type === 'select') {
            properties[property.id] = property.options?.[0]?.id;
          }

          if (property.type === 'multiSelect') {
            properties[property.id] = property.options?.slice(0, 2).map((option) => option?.id);
          }
        });

        return {
          _id: '1234567890',
          event: useEventStore().event?._id,
          properties,
          status: {
            confirmation: 0,
            attendance: 0,
          },
          guestAppData: {
            accessCode: 123456,
          },
        };
      };
    },
  },
});
